var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_25454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 5.53333V3H24V5.53333H14.4ZM14.4 10.6V8.06667H24V10.6H14.4ZM14.4 15.6667V13.1333H24V15.6667H14.4ZM7.2 14.4C6.2 14.4 5.35 14.0306 4.65 13.2917C3.95 12.5528 3.6 11.6556 3.6 10.6C3.6 9.54444 3.95 8.64722 4.65 7.90833C5.35 7.16944 6.2 6.8 7.2 6.8C8.2 6.8 9.05 7.16944 9.75 7.90833C10.45 8.64722 10.8 9.54444 10.8 10.6C10.8 11.6556 10.45 12.5528 9.75 13.2917C9.05 14.0306 8.2 14.4 7.2 14.4ZM0 22V19.5933C0 19.15 0.1 18.7278 0.3 18.3267C0.5 17.9256 0.78 17.6089 1.14 17.3767C2.04 16.8067 2.995 16.3792 4.005 16.0942C5.015 15.8092 6.08 15.6667 7.2 15.6667C8.32 15.6667 9.385 15.8092 10.395 16.0942C11.405 16.3792 12.36 16.8067 13.26 17.3767C13.62 17.6089 13.9 17.9256 14.1 18.3267C14.3 18.7278 14.4 19.15 14.4 19.5933V22H0ZM2.58 19.4667H11.82C11.12 19.0444 10.38 18.7278 9.6 18.5167C8.82 18.3056 8.02 18.2 7.2 18.2C6.38 18.2 5.58 18.3056 4.8 18.5167C4.02 18.7278 3.28 19.0444 2.58 19.4667ZM7.2 11.8667C7.54 11.8667 7.825 11.7453 8.055 11.5025C8.285 11.2597 8.4 10.9589 8.4 10.6C8.4 10.2411 8.285 9.94028 8.055 9.6975C7.825 9.45472 7.54 9.33333 7.2 9.33333C6.86 9.33333 6.575 9.45472 6.345 9.6975C6.115 9.94028 6 10.2411 6 10.6C6 10.9589 6.115 11.2597 6.345 11.5025C6.575 11.7453 6.86 11.8667 7.2 11.8667Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccount);
export default __webpack_public_path__ + "static/media/user-account.064f8b460c7210ef6e998ed8a8f3a53f.svg";
export { ForwardRef as ReactComponent };